import React from "react";
import {
  Dimensions,
  Modal,
  StyleSheet,
  TouchableOpacity,
  Text,
  View,
} from "react-native";
import { Color, globalFontStyle, globalStyle } from "../../../assets";
import Width from "../../../assets/Width";
import FastImage from "../../../common/FastImage";
import {Button} from "../../../components/core/Button";
import {order_yes_contract, tick_new} from "../../../utils/images";
import {isMobile} from "../../../utils/commonMethods";
import Colors from "../../../assets/Color/Colors";
import {globalConfigurableData} from "../../../utils/globalConstant";

const LiquidityStatus = ({ orderData, onDoneClick, isRemoveLiquidity }) => {
  const finalUserLiquidity = orderData?.finalUserLiquidity;
  const userPositionsData = orderData?.userPositionsData;
  const responseObj = [
    {
      title: "Liquidity value added",
      val:
        "" +
        (
          finalUserLiquidity?.liquidity_tokens_count *
          finalUserLiquidity?.liquidity_tokens_issue_price
        )?.toFixed(2),
    },
    {
      title: "Liquidity shares",
      val: finalUserLiquidity?.liquidity_tokens_count?.toFixed(2),
    },
    {
      title: "Shares Received",
      val: userPositionsData
        ? userPositionsData?.callvalue == "Y"
          ? `Yes ${userPositionsData?.noofcontracts?.toFixed(2)}`
          : `No ${userPositionsData?.noofcontracts?.toFixed(2)}`
        : "0.0",
    },
  ];
  return (
      <View style={{ flex: 1, padding: 10, paddingHorizontal: 15  }}>
        <View
            style={{
              width: isMobile() ? Width.width - 30 : "auto",
              flex: 1,
              paddingTop: isMobile() ? 15 : 30,
            }}
        >
          <FastImage
              style={{
                width: 60,
                height: 60,
                alignSelf: "center",
                marginBottom: 20,
              }}
              source={globalConfigurableData?.tick_new()}
          ></FastImage>
          <Text style={[styles.orderStatusText]}>{isRemoveLiquidity ? "Liquidity Removed Successfully" : "Liquidity Added Successfully"}</Text>
          {!isRemoveLiquidity && (<View style={styles.tableContainer}>
            {responseObj.map((item, index) => {
              return (
                  <View
                      key={index}
                      style={[
                        styles.tableRow,
                        index === responseObj.length - 1
                            ? { borderBottomWidth: 0,}
                            : null,
                      ]}
                  >
                    <Text style={{...styles.textFontStyle, color: globalConfigurableData.secondaryTextColor1}}>{item.title}</Text>
                    <Text style={styles.textFontStyle}>{item.val}</Text>
                  </View>
              );
            })}
          </View>)}
          {orderData?.unmatched ? (
              <Text style={[styles.failedOrderText]}>
                Looking for users with opposite position to match your order.
              </Text>
          ) : null}
          <View style={[globalStyle.customBtnParentModalStyle]}>
            <Button
                variant="primary"
                onPress={onDoneClick}
                translate={true}
            >
                Done
            </Button>
          </View>
        </View>
      </View>
  );
};

export default LiquidityStatus;

const styles = StyleSheet.create({
  orderStatusText: {
    ...globalFontStyle.appFontTitle,
    alignSelf: "center",
    marginBottom: 40,
    textAlign: "center",
    color: globalConfigurableData.primaryTextColor1,
  },
  textFontStyle: {
    ...globalFontStyle.appFontSubText,
    color: globalConfigurableData.primaryTextColor1,
  },
  tableRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    borderBottomWidth: 0.75,
    borderColor: globalConfigurableData.borderColor,
    paddingHorizontal: 18,
    paddingVertical: 15,
  },
  tableContainer: {
    borderWidth: 0.75,
    borderColor: globalConfigurableData.borderColor,
    borderRadius: 10,
    //paddingHorizontal: 18,
    marginBottom: 30,
  },
  failedOrderText: {
    ...globalFontStyle.appFontSubText,
    color: globalConfigurableData.tertiaryTextColor1,

    textAlign: "center",
  },
});
